import { render, staticRenderFns } from "./ChildBriefRecord.vue?vue&type=template&id=03551051&"
import script from "./ChildBriefRecord.vue?vue&type=script&lang=js&"
export * from "./ChildBriefRecord.vue?vue&type=script&lang=js&"
import style0 from "./ChildBriefRecord.vue?vue&type=style&index=0&id=03551051&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports